import React from "react";
import { Box } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";

import { EsgBriefcase } from "assets";
import { capitalizeAllStringWithSeparator, capitalizeString, formatFriendlyDate, isNullOrUndefined } from "utils";

export const JOBS_PAGE = {
  ABSOLUTE_PATH: "/jobs",
  PATH: "",
  TITLE: "Jobs",
  ICON: <EsgBriefcase />,
  renderMenu: false,
};

export const jobsColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "name",
    header: "Job Name",
    Cell: ({ cell }) => {
      let value = cell.getValue<string>();

      if (value?.includes("_")) {
        value = value.split("_").join(" ");
        value = capitalizeString(value) as string;
      }

      return value;
    },
  },
  {
    accessorKey: "fileName",
    header: "Filename",
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();

      if (isNullOrUndefined(value) || value === "") {
        return "-"
      }

      return value;
    },
  },
  {
    accessorKey: "createDate",
    header: "Date",
    Cell: ({ cell }) => {
      const value = cell.getValue<string>();

      return (
        <div>
          <span>{formatFriendlyDate(value, true)}</span>
        </div>
      );
    },
    sortingFn: (rowA, rowB) => {
      const dateA = new Date(rowA.original.createDate).getTime();
      const dateB = new Date(rowB.original.createDate).getTime();

      return dateA - dateB;
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    Cell: ({ cell }) => {
      const statusValue = cell.getValue() as string;

      const statusParser: any = {
        processed: "DONE",
        uploaded: "DONE",
        success: "DONE",
        processing: "IN_PROGRESS",
        pending: "IN_PROGRESS",
        in_progress: "IN_PROGRESS",
        partially_success: "IN_PROGRESS",
        error: "BLOCKED",
        not_completed: "NOT_COMPLETED",
      };

      if (!statusValue) return "";

      const statusIdParsed: string = statusParser[`${statusValue.toLowerCase()}`];

      const BoxResult = ({ status }: { status: string }) => {
        const statusColors: Record<string, { backgroundColor: string; color: string }> = {
          IN_PROGRESS: { backgroundColor: "#FEF9C3", color: "#854D0E" },
          BLOCKED: { backgroundColor: "#FFF4F4", color: "#C92A2A" },
          DONE: { backgroundColor: "#E1EFE6", color: "#388010" },
          NOT_COMPLETED: { backgroundColor: "#E1EFE6", color: "#DD7615" },
        };

        const backgroundColor = statusColors[status]?.backgroundColor || "transparent";

        return (
          <Box sx={{
            width: "fit-content",
            backgroundColor,
            color: statusColors[status]?.color || "#000",
            padding: "0 12px",
            borderRadius: "8px",
            fontWeight: "500",
          }}>
            {capitalizeAllStringWithSeparator(statusValue, "_")}
          </Box>
        );
      }

      return (
        <BoxResult status={statusIdParsed} />
      );
    },
  },
  {
    accessorKey: "type",
    header: "Message",
  },
]
